import { Box, Grid } from "@mui/material";
import SideBarMenu from "./Sidebar";
import LandingHeader from "../Landing/Header";
import LandingFooter from "../Landing/Footer";

const LandingMain = (props: any = null) => {
  return (
    <>
      <Box className="livis-part-wraps">
        <div className="livis-auth-header-wrap">
          <LandingHeader landing_page_props={props.landing_page_props} />
        </div>
        <div className="livis-part-body-wrap">
          <Grid container className="livis-settings-main-side-wrap">
            <Grid
              className="livis-settings-sidebar-menu-wrap"
              item
              lg={1.52}
              md={12}
              sm={12}
              xs={12}
              sx={{position: "sticky", top: "0", alignSelf: "flex-start"}}
            >
              <SideBarMenu />
            </Grid>

            <Grid
              className="livis-settings-part-main-wrap"
              item
              lg={10.48}
              md={12}
              sm={12}
              xs={12}
            >
              {props.children}
            </Grid>
          </Grid>
        </div>
        <div className="livis-part-footer-wrap">
          <LandingFooter />
        </div>
      </Box>
    </>
  );
};

export default LandingMain;
